@if (diffMinutes() >= 120 || !stateOfCharge()?.sensorValue) {
  <img [src]="path" alt="battery-question-mark"
        [title]="!stateOfCharge() 
            ? ('Could not find any state of charge history for this vehicle' | translate)
            : diffMinutes() >= 120 
                ? ('Battery status is older than 2 hours' | translate) 
                : ''"
    />
  } @else {
    <i class="icon fas {{iconName()}}"
      [title]="diffMinutes() >= 10 ? ('Battery status is older than 10 minutes' | translate) : ''"
      >
    </i> {{stateOfCharge()?.sensorValue ?? ''}}%
  }

